import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Http } from '@angular/http';
import * as emiGlobals from 'app/globals';

// Define interfaces for the expected response structures
interface TokenResponse {
  token: string;
}

interface LeadResponse {
  leads: any[];
}

@Injectable()
export class LeadResolver implements Resolve<any> {
  constructor(private http: Http) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
    const leadId = route.queryParamMap.get('leadId');
    if (leadId) {
      return this.getToken()
        .then((token) => this.getLeadById(leadId, token))
        .catch((error) => {
          console.error('Error fetching lead:', error);
          return null;
        });
    } else {
      return Promise.resolve(null);
    }
  }

  private getToken(): Promise<string> {
    const apiUrl = emiGlobals.jwtTokenUrl;
    return this.http.get(apiUrl).toPromise()
      .then(response => {
        const body = response.json() as TokenResponse;
        localStorage.setItem('id_token', body.token);
        return body.token;
      });
  }

  private getLeadById(leadId: string, token: string): Promise<any> {
    const apiUrl = `${emiGlobals.getLeadByIdUrl}/${leadId}?token=${token}`;
    return this.http.get(apiUrl).toPromise()
      .then(response => {
        const body = response.json() as LeadResponse;
        return body.leads[0];
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/service/lead.resolve.ts